
























































import { Component, Vue } from "vue-property-decorator";
import { ConsultoresService, Transacao } from "@/services/consultores.service";
import Modal from "@/shared/components/modal.vue";
import { dateTimeSeconds } from "@/shared/filters";

@Component({
  components: {
    Modal,
  },
  filters: { dateTimeSeconds },
})
export default class ProcessarTransacaoPagseguro extends Vue {
  idTransacao = "";
  loading = false;
  mostrarCampos = true;
  mensagem = "";

  dadosTransacao: Transacao = {
    date: "",
    lastEventDate: "",
    transactionDescription: "",
  };

  get tituloManter(): string {
    return "Status da transação no PagSeguro";
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async statusTransacao(idTransacao: string) {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();
    this.idTransacao = idTransacao;
    this.loading = true;
    try {
      const retorno = await ConsultoresService.ConsultarTransacao(idTransacao);
      if (!retorno.sucess) {
        this.mostrarCampos = false;
        this.mensagem = retorno.resposta;
      } else {
        this.mostrarCampos = true;
        this.dadosTransacao = retorno.resposta.transacao;
      }
      this.loading = false;
    } finally {
      this.loading = false;
    }
    return p;
  }

  async processarStatus() {
    const modal = this.$refs.modal as Modal;
    this.loading = true;
    try {
      await ConsultoresService.ProcessarStatus(this.idTransacao);
    } catch {
      this.loading = false;
    }
    this.loading = false;
    modal.close(false);
  }
}
